module.exports = __webpack_public_path__ + "static/media/3-AirHeatExchanger - DX cool - Water heat.1bb5cf60.png";